
import { useState } from 'react';
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_RESERVAR =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

const faqs = [
  {
    question: "¿Necesita experiencia previa?",
    answer:
      "No, el curso está diseñado para cualquier nivel. No necesitás saber programar ni tener experiencia técnica. Solo traé tu notebook y ganas de aprender.",
  },
  {
    question: "¿Puedo pagar en cuotas?",
    answer:
      "Sí, podés pagar con tarjeta de crédito en cuotas con interés. Consultanos por WhatsApp para conocer las opciones disponibles.",
  },
  {
    question: "¿Hay descuento por transferencia?",
    answer:
      "Sí, pagando por transferencia bancaria tenés un 5% de descuento sobre el precio de la entrada.",
  },
  {
    question: "¿Cómo sé que quedé inscripto?",
    answer:
      "Una vez que completás el formulario y realizás el pago, te enviamos una confirmación por WhatsApp con todos los detalles del evento.",
  },
  {
    question: "¿Puedo ir con mi socio o equipo?",
    answer:
      "¡Sí! Tenemos packs especiales para equipos de 2 y 3 personas con descuento. Consultá la sección de Entradas y Packs.",
  },
  {
    question: "¿Qué pasa si me atraso con el precio anticipado?",
    answer:
      "Si la fecha de venta anticipada ya pasó, podés comprar tu entrada al precio general. Te recomendamos no esperar para asegurar tu lugar.",
  },
];

export default function PreguntasFrecuentes() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold mb-12 text-center">
              Preguntas frecuentes
            </h2>
          </AnimatedSection>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <AnimatedSection key={faq.question} animation="fadeUp" delay={index * 80}>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden">
                  <button
                    onClick={() => toggle(index)}
                    className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-white/5 transition-all cursor-pointer"
                  >
                    <h3 className="text-lg font-semibold pr-4">{faq.question}</h3>
                    <i
                      className={`text-2xl text-teal-400 flex-shrink-0 transition-transform duration-300 ri-arrow-down-s-line ${
                        openIndex === index ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="px-8 pb-6">
                      <p className="text-gray-300">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center mt-12">
              <a
                href={WA_RESERVAR}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
              >
                Reservar ahora
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
